<template>
  <div class="college-dict">
    <table-list
      title="综合分类列表"
      :loading="loading"
      :search-form="searchForm(this)"
      :data="tagList"
      :columns="columns(this)"
      :operates="operates(this)"
      :btns="btns(this)"
      row-key="id"
      :options="{ selection: true, operatesWidth: 210 }"
      :pager="pager"
      @search="onSearch"
      @selectionChange="handleSelectionChange"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    ></table-list>
    <AddModal ref="AddModal" :tag-type-list="tagTypeList" @success="getTagList"></AddModal>
  </div>
</template>
<script>
const btns = _this => [
  {
    label: '添加标签',
    method: _this.handleAdd,
    type: 'primary',
  },
  {
    label: '批量删除',
    method: _this.handleBatchDelete,
    type: 'danger',
  },
]

const searchForm = _this => [
  {
    label: '标签名称',
    prop: 'name',
  },
  {
    label: '标签状态',
    type: 'select',
    prop: 'status',
    children: [
      { value: true, label: '启用' },
      { value: false, label: '禁用' },
    ],
  },
  {
    label: '类型',
    type: 'select',
    prop: 'tagTypeId',
    children: _this.tagTypeList.map(item => ({
      value: item.key,
      label: item.value,
    })),
  },
]

const columns = _this => [
  {
    prop: 'id',
    label: '标签ID',
    minWidth: 200,
  },
  {
    prop: 'name',
    label: '标签名称',
    minWidth: 200,
  },
  {
    prop: 'tagTypeName',
    label: '标签类型',
    minWidth: 200,
  },
  {
    label: '启用状态',
    minWidth: 150,
    render: (h, { row }) => {
      return [
        h('el-switch', {
          props: { value: row.status, activeValue: true, inactiveValue: false },
          on: {
            change: v => {
              _this.handleStatusChange(v, row)
            },
          },
        }),
      ]
    },
  },
]

const operates = _this => [
  {
    label: '编辑',
    method: _this.handleEdit,
  },
  {
    label: '删除',
    method: _this.handleDelete,
    type: 'text',
    color: '#f56c6c',
  },
]

import TableList from '@/components/TableList'
import to from 'await-to'
import {
  tagList,
  tagTypeFilter,
  tagStatusUpdate,
  tagListBatchDelete,
  tagListDelete,
} from '@/api/system'
import AddModal from './compenents/addModal'
export default {
  name: 'CollegeDict',
  components: {
    TableList,
    AddModal,
  },
  data() {
    return {
      btns,
      searchForm,
      columns,
      operates,
      loading: false,
      tagList: [],
      pager: {
        total: 0,
        size: 10,
        current: 1,
      },
      selectTags: [],
      queryParams: {},
      tagTypeList: [],
    }
  },
  mounted() {
    this.handleTagTypeFilter()
    this.getTagList()
  },
  methods: {
    async handleTagTypeFilter() {
      const [res, err] = await to(tagTypeFilter({}))
      if (err) return this.$message.warning(err.msg)
      this.tagTypeList = res.data
    },
    async getTagList() {
      if (this.loading) return
      const { current, size } = this.pager
      this.loading = true
      const [res, err] = await to(tagList({ current, size, ...this.queryParams }))
      this.loading = false
      if (err) return this.$message.warning(err.msg)
      this.tagList = res.data.list
      this.pager.total = res.data.total
    },
    onSearch(queryParams) {
      this.pager.current = 1
      this.queryParams = queryParams
      this.getTagList()
    },
    handleAdd() {
      this.$refs.AddModal.show()
    },
    handleEdit(row) {
      this.$refs.AddModal.show(row)
    },
    async handleDelete(row) {
      this.$confirm('确认删除该标签吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [, err] = await to(tagListDelete({ id: row.id }))
          if (err) return this.$message.warning(err.msg)
          this.$message({ message: '删除成功', type: 'success' })
          this.getTagList()
        })
        .catch(() => {})
    },
    async handleBatchDelete() {
      if (!this.selectTags.length) return this.$message.warning('请先选择要删除的标签')
      const idList = this.selectTags.map(item => item.id)
      this.$confirm('确认删除选中的标签吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [, err] = await to(tagListBatchDelete({ idList: idList }))
          if (err) return this.$message.warning(err.msg)
          this.$message({ message: '删除成功', type: 'success' })
          this.getTagList()
        })
        .catch(() => {})
    },
    async handleStatusChange(v, row) {
      const [, err] = await to(tagStatusUpdate({ id: row.id, status: v }))
      if (err) return this.$message.warning(err.msg)
      this.$message.success('操作成功')
      this.getTagList()
    },
    // 多选
    handleSelectionChange(val) {
      this.selectTags = val
    },
    // 分页
    handleSizeChange(size) {
      this.pager.current = 1
      this.pager.size = size
      this.getTagList()
    },
    handleCurrentChange(current) {
      this.pager.current = current
      this.getTagList()
    },
  },
}
</script>
